import './styles.scss';

import React, {CSSProperties, useEffect, useRef, useState} from 'react';

interface AppLoaderProps {
    style?: CSSProperties;
    fullScreen?:boolean;
    delay?: number;
}

export const AppLoader = ({style, fullScreen, delay = 300}: AppLoaderProps) => {
    const [display, setDisplay] = useState(false);
    const timeoutRef = useRef<NodeJS.Timeout>();

    useEffect(() => {
        timeoutRef.current = setTimeout(() => setDisplay(true), delay);

        return () => {
            if(timeoutRef.current) { clearTimeout(timeoutRef.current); }
        };
    }, [delay]);

    if(display){
        return <div className={`app-loader ${fullScreen ? 'app-loader-full' : ''}`} style={style} />;
    }

    return null;
};
